import { useCallback, useEffect } from 'react';
import 'antd/dist/reset.css';
import './styles/ant-config.css';
import { Layout } from 'antd';
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import Dashboard from '~/pages/Dashboard';
import Landing from '~/pages/Landing';
import Sidebar from './components/Sidebar/Sidebar';
import Apply from './pages/Apply';
import Service from './pages/Service';
import { loadUser } from './services/authService';
import { useAuthStore } from './store/auth';
import PrivateRoute from './utils/PrivateRoute';
import { SIB_REFERRER_ID, isSIBHost } from './utils/constants';
import notify from './utils/useNotification';
import { getCookie } from './utils/utilities';

const { Content } = Layout;

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useAuthStore();

  const checkForLoginError = useCallback(() => {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.get('error') === '1') {
      notify({
        type: 'error',
        title: 'Google Login Failed',
        description:
          'Login failed or insufficient permissions. Please try again.',
      });
      searchParams.delete('error');
      navigate(`${location.pathname}?${searchParams.toString()}`);
    }
  }, [location, navigate]);

  const loadUserData = async () => {
    const cookieValue = getCookie('smallswitch_Users');
    if (cookieValue) {
      const userData = JSON.parse(cookieValue);
      if (userData?.email) {
        const checkAuth = await loadUser();
        if (!checkAuth) {
          navigate('/');
        }
      }
    }
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies:
  useEffect(() => {
    loadUserData();
    checkForLoginError();
  }, []);

  /* is user is authenticated then we will redirect him dashboard when they tries to navigate to the landingPage */
  useEffect(() => {
    if (isAuthenticated && location.pathname === '/' && !isSIBHost()) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, location.pathname, navigate]);

  return (
    <Layout className="min-h-[100vh]">
      <Sidebar />
      <Layout>
        <Content>
          <Routes>
            <Route
              path="/"
              element={
                isSIBHost() ? (
                  <Navigate to={`/apply/${SIB_REFERRER_ID}`} replace />
                ) : (
                  <Landing />
                )
              }
            />
            <Route
              path="/dashboard"
              element={<PrivateRoute element={<Dashboard />} />}
            />
            <Route path="/apply/:referrerId" element={<Apply />} />
            <Route path="/service" element={<Service />} />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
}

export default App;
